const monthLookup = {
  "01": "January",
  "1": "January",
  "02": "February",
  "2": "February",
  "03": "March",
  "3": "March",
  "04": "April",
  "4": "April",
  "05": "May",
  "5": "May",
  "06": "June",
  "6": "June",
  "07": "July",
  "7": "July",
  "08": "August",
  "8": "August",
  "09": "September",
  "9": "September",
  "10": "October",
  "11": "November",
  "12": "December"
};
//expected input is date as string in ISO format (YYYY-MM-DD)
//expected output is date as string in US English format (e.g. Month DD, YYYY or Month YYYY or YYYY)
//expected output if date is not in ISO format is to return date without change
const formatDate = (date) => {
  try {
    if (date) {
      let dateSplit = date.replace(/\//g, '-').split("-");
      if (dateSplit[0].length === 4 && !isNaN(dateSplit[0]) && (dateSplit[0][0] !== '+')) {
        if (dateSplit.length >= 2 && monthLookup[dateSplit[1]]) {
          if (dateSplit.length === 3 && date.length <= 10 && date.length >= 8) {
            return monthLookup[dateSplit[1]] + " " + dateSplit[2] + ", " + dateSplit[0];
          } else if (dateSplit.length === 2) {
            return monthLookup[dateSplit[1]] + " " + dateSplit[0];
          }
        }
      }
    }
  } catch (e) {
    console.log("ERROR with formatDate function");
    console.log(e);
  }
  return date;
}

export default formatDate;